import Header from './components/Header';
import { Outlet, useLocation, useNavigationType } from 'react-router-dom';
import Footer from './components/Footer';
import useOnlineStatus from './hooks/useOnlineStatus';
import { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeMenu } from './features/app/appSlice';

const App = ({id}) => {
  const { pathname } = useLocation();
  const location = useLocation();
  const navigationType = useNavigationType();
  const isOnline = useOnlineStatus();
  const { isMenuOpen } = useSelector(state => state.app);
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    // Preserve browser scroll on back/forward (POP). Scroll to top on fresh navigations.
    if (navigationType !== 'POP') {
      window.scrollTo(0, 0);
    }

    // close menu, if open
    isMenuOpen && dispatch(closeMenu());
  }, [pathname, navigationType, isMenuOpen, dispatch]);

  // Ensure `id` query param (userCode) stays in the URL on route changes
  useLayoutEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!params.get('id')) {
      const stored = window.sessionStorage.getItem('userCode');
      if (stored) {
        params.set('id', stored);
        const newUrl = `${location.pathname}?${params.toString()}`;
        window.history.replaceState(null, '', newUrl);
      }
    }
  }, [location.pathname]);

  return (
    <>
      {isOnline ? (
        <>
          <Header pathname={pathname} id={id} />
          <Outlet />
          <Footer pathname={pathname} />
        </>
      ) : (
        <div className='flex flex-col justify-center items-center min-h-screen'>
          <h1 className='text-4xl font-bold'>Oops! Connection lost</h1>
          <p>
            Looks like you're offline, please check your internet connection.
          </p>
        </div>
      )}
    </>
  );
};

export default App;
